module.exports = __webpack_public_path__ + "cf5ba39d9ac24652e25df8c291121506.ttf";